<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
          <span class="pointer" @click="handleDeal('projectDetail', row.id)"
            >详情</span
          >
        </template> -->
      </Table>
      <!-- <Page
        class="page"
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page> -->
    </div>
  </div>
</template>
<style scoped></style>
<script>
import tableMixin from "@/components/tableMixin";
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableMixin, tableTwoMixin],
  data() {
    return {
      tableData: [],
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "企业统一社会信用代码",
          key: "corpCode",
          minWidth: 210,
          tooltip: true,
        },
        { title: "企业名称", key: "corpName", minWidth: 180, tooltip: true },
        { title: "单位性质", key: "corpType", minWidth: 180, tooltip: true },
        {
          title: "工商营业执照注册号",
          key: " licenseNum",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "企业注册地区编码",
          key: "areaCode",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "企业营业地址",
          key: "address",
          minWidth: 210,
          tooltip: true,
        },
        {
          title: "邮政编码",
          key: "zipCode",
          minWidth: 210,
          tooltip: true,
        },
        {
          title: "法定代表人姓名",
          key: "legalMan",
          minWidth: 210,
          tooltip: true,
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "法定代表人职务",
          key: "legalManDuty",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "法定代表人职称",
          key: "legaManProTitle",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "法定代表人证件类型",
          key: "legalManIDCardType",
          align: "right",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "法定代表人证件号码",
          key: "legalManIDCardNumber",
          align: "right",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "注册资本（万元）",
          align: "center",
          key: "regCapital",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "实收资本(万元)",
          align: "center",
          key: "factRegCapital",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "注册资本币种",
          align: "center",
          key: "capitalCurrencyType",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "注册日期",
          align: "center",
          key: "registerDate",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "成立日期",
          align: "center",
          key: "establishDate",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "办公电话",
          align: "center",
          key: "officePhone",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "传真号码",
          align: "center",
          key: "faxNumber",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "联系人姓名",
          align: "center",
          key: "linkman",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "联系人办公电话",
          align: "center",
          key: "linkTel",
          minWidth: 180,
          tooltip: true,
        },
        { title: "企业联系邮箱", key: "email", minWidth: 180, tooltip: true },
        { title: "企业联系邮箱", key: "email", minWidth: 180, tooltip: true },
        { title: "企业网址", key: "website", minWidth: 180, tooltip: true },
        { title: "企业备注", key: "remark", minWidth: 180, tooltip: true },
        { title: "数据来源", key: "areaCode", minWidth: 180, tooltip: true },
      ],
      dataType: "",
      optId: "",
    };
  },
  created() {
    console.log(this.$route.query);
  },
};
</script>
